export type OptionLayoutState = {
  header: boolean;
  resume_step: boolean;
  breadcrumb: boolean;
  footer: boolean;
  webcallback: boolean;
  subscriberCG: boolean;
  sizeXL: boolean;
  vertical_align: boolean;
  step_check_email: boolean;
  form_error_submit: boolean;
  summaryOffers: boolean;
};

export const initialOptionLayoutState: OptionLayoutState = {
  header: true,
  resume_step: true,
  breadcrumb: true,
  footer: true,
  webcallback: true,
  subscriberCG: false,
  sizeXL: false,
  vertical_align: false,
  step_check_email: true,
  form_error_submit: false,
  summaryOffers: false
};
